import { useState } from "react";

import PropTypes from "prop-types";

import { formatDate } from "common/functions";

import { FaSearch } from "components/atoms/Icon/fa/FaSearch";
import { FiCalendar } from "components/atoms/Icon/fi/FiCalendar";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FormNewsletter from "components/molecules/FormNewsletter";
import PostItem from "components/molecules/PostItem";
import Banner from "components/organisms/Banner";

import Slider from "./Slider";

const Component = ({ data, posts, categories }) => {
  const [keyWord, setKeyWord] = useState();
  const [results, setResults] = useState([]);
  const firstPost = posts[0] || {};
  const category = firstPost?.categories?.nodes.filter(
    (item) => item.parent === null
  );

  const handleSearch = (keyWord) => {
    const keyWordLowerCase = keyWord.toLowerCase().trim();

    setKeyWord(keyWordLowerCase);
    setResults(
      keyWordLowerCase
        ? posts.filter(
            (item) =>
              item?.title.toLowerCase().trim().includes(keyWordLowerCase) ||
              item?.excerpt
                .replace(/<[^>]+>/g, "")
                .toLowerCase()
                .trim()
                .includes(keyWordLowerCase)
          )
        : []
    );
  };

  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-fix-min-h-569"
          title={data?.banner?.title}
          // Author="Content team"
          breadcrumbs={data?.banner?.breadcrumbs}
          description={data?.banner?.description}
          bgColor="bg-bbc-gradient-8"
          // TimeRead="20 min read"
          // Date="18/02/2022"
          // DataTrustpilot={trustpilot}
          leftClassName="relative lg:mt-0 col-12 lg:col-5"
          // LeftClassName="relative mt-4 lg:mt-0 col-12 lg:col-8 xl:col-7 lg:max-w-[665px]"
          // RightClassName="relative col-12 lg:col-4 xl:col-5"
          rightClassName={`relative col-12 lg:col-7 text-center ${
            data?.banner?.className ? data?.banner?.className : "lg:-mt-[70px]"
          }`}
          rightContent={
            <Img
              src={data?.banner?.image?.src}
              width={559}
              height={474}
              className={`${
                data?.banner?.classNameImg
                  ? data?.banner?.classNameImg
                  : "max-w-[375px]"
              } lg:w-full lg:max-w-full`}
              alt="banner"
              priority={true}
            />
          }
        ></Banner>
      </section>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12 lg:col-8">
              <div className="overflow-hidden rounded-[49px] border border-bbc-neutral-600">
                <div className="row">
                  <div className="col">
                    <input
                      type="text"
                      placeholder="Enter your keyword"
                      onChange={(e) => handleSearch(e.target.value)}
                      className="form-input h-10 w-full border-0 bg-transparent px-4 tracking-[0.25px] text-[rgba(51,51,51,0.5)] focus:ring-0"
                    />
                  </div>
                  <div className="col-auto flex items-center justify-center">
                    <div className="px-4">
                      <FaSearch className="text-bbc-neutral-600" size={18} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {keyWord ? (
            <></>
          ) : (
            <div className="mt-10">
              <div>
                {!keyWord && firstPost ? (
                  <div className="overflow-hidden rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]">
                    <div className="flex flex-col lg:flex-row">
                      <div className="pr-0 lg:col-8 lg:pr-[15px]">
                        <Img
                          alt=""
                          image={firstPost?.featuredImage?.node}
                          wrapper={{ className: "w-full relative" }}
                          className="aspect-[16/9] h-full w-full object-cover"
                        />
                      </div>
                      <div className="col-12 flex flex-col justify-center px-[15px] py-4 lg:col-4">
                        <Title
                          as="h3"
                          className="text-lg  font-semibold text-bbc-brand-800 line-clamp-2 lg:text-2xl lg:leading-9 lg:line-clamp-3"
                        >
                          <Link href={firstPost?.uri}>{firstPost?.title}</Link>
                        </Title>
                        <div
                          className="mt-4 line-clamp-3 lg:mt-6"
                          dangerouslySetInnerHTML={{
                            __html: firstPost.excerpt,
                          }}
                        />
                        <div className="flex flex-wrap justify-between">
                          <div className="mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5">
                            <Img
                              src={`/assets/icons/${category[0].name.toLowerCase()}.svg`}
                              alt="icon"
                              width={16}
                              height={16}
                            />
                            <span className="inline-block pl-[5px] text-sm font-medium text-white">
                              {category.length > 0 && category[0].name}
                            </span>
                          </div>
                          <div className="mt-6 inline-flex items-center">
                            <FiCalendar size={18} />
                            <span className="inline-block pl-2 text-sm">
                              {formatDate(firstPost?.date)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          )}
          {results.length > 0 ? (
            <div className="row -mx-4 mt-8 gap-y-8">
              {results.map((item, index) => (
                <div className="col-12 px-4 lg:col-4" key={index}>
                  <PostItem post={item} />
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
          {(keyWord && !(results.length > 0)) ||
          !posts ||
          !(posts.length > 0) ? (
            <div className="border-primary text-primary mt-8 border-l-4 bg-[#fff5e3] py-4 px-6 text-center">
              No results
            </div>
          ) : (
            <></>
          )}
        </div>
      </section>
      {!keyWord && (
        <section>
          {categories?.nodes.length > 0 &&
            categories?.nodes.map((item, index) => (
              <Slider
                key={index}
                id={index}
                category={item}
                posts={posts.filter((element) =>
                  element.categories.nodes.find(
                    (nodes) => nodes.name === item.name
                  )
                )}
              />
            ))}
        </section>
      )}
      <FormNewsletter />
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Component.defaultProps = {
  data: {},
  posts: [],
};
